import { configureStore, Middleware } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import {
  answersSlice,
  phonesSlice,
  rootSaga,
  scenarioSlice,
  stepSlice,
  progressSlice,
  referrerSlice,
  phonesSliceCondensed,
} from '../state'
import createSagaMiddleware from 'redux-saga'
import { redirectionUrlSlice } from '../state/redirection-url-slice'
import { searchTextSlice } from '../state/search-text-slice'

export interface StoreOptions<S = Record<string, unknown>> {
  withLogger: boolean
  preloadedState?: S
}

const defaultOptions: StoreOptions = {
  withLogger: !true,
}

export const rootReducer = {
  scenario: scenarioSlice.reducer,
  phones: phonesSlice.reducer,
  phonesCondensed: phonesSliceCondensed.reducer,
  step: stepSlice.reducer,
  answers: answersSlice.reducer,
  progress: progressSlice.reducer,
  referrerUrl: referrerSlice.reducer,
  redirectionUrl: redirectionUrlSlice.reducer,
  searchText: searchTextSlice.reducer,
}

export const initStore = (storeOptions = defaultOptions) => {
  const { withLogger, preloadedState } = storeOptions
  const sagaMiddleware = createSagaMiddleware()

  const store = configureStore({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reducer: rootReducer as any,
    preloadedState,
    middleware: (getDefaultMiddleware) => {
      const base = getDefaultMiddleware().concat(sagaMiddleware as unknown as Middleware)
      return withLogger ? base.concat(logger as unknown as Middleware) : base
    },
  })

  sagaMiddleware.run(rootSaga)

  return store
}
